import axios from 'axios';

export const state = {
    negotiations: {}
};

export const mutations = {
    SET_NEGOTIATIONS (state, newValue) {
        state.negotiations = newValue;
    },
    CLEAR (state) {
        state.negotiations = {};
        state.notifications = [];
    }
};

export const getters = {
    hasNegotiationsData (state) {
        return Object.keys(state.negotiations).length > 0;
    }
};

export const actions = {
    async getNegotiationsData({ commit }, type = '') {
        const agreements = await axios.get(`${type}/campaign-agreement`);
        const notifications = await axios.get('/notification/campaign-agreement');
        attachNotifications(agreements.data, notifications.data);
        commit('SET_NEGOTIATIONS', agreements.data);
    }
};

// attach notifications to responding campaign agreement
function attachNotifications (agreements, notifications) {
    notifications.forEach( notification => {
        Object.keys(agreements).forEach( key => {
            agreements[key].forEach( agreement => {
                    if ( agreement._id === notification.sourceable_id) {
                    if (!agreement.notifications) {
                        agreement.notifications = [];
                    }
                    agreement.notifications.push(notification);
                }
            });
        });
    });
}